#pragma glslify: noise = require('glsl-noise/simplex/3d')
#pragma glslify: rotate2d = require('../lib.glsl')
#pragma glslify: ease = require(glsl-easings/quartic-in)
#pragma glslify: random = require(glsl-random) 

uniform float uTime;
uniform float uSeed;
uniform float uVisibilityProgress;
uniform float uScale;
uniform float uAr;
uniform sampler2D tDiffuse;
varying vec2 vUv;

void main() {
  float oneMinusVisibilityProgress = 1.0 - uVisibilityProgress;

  float scaleU = 1.0 / uScale;
  float scaleV = (1.0 / uScale) * uAr;
  vec2 translateUv = vUv - vec2((1.0 - uScale) / 2.0, (1.0 - uScale / uAr) / 2.0);
  vec2 scaledUv = translateUv * vec2(scaleU, scaleV);

  vec2 centeredUv = vUv - 0.5;
  vec2 noiseSampleUv = (centeredUv * 4.0) * (1.0 + oneMinusVisibilityProgress * 0.8);

  float noiseSample = noise(vec3(noiseSampleUv, (uSeed * 100.0) + uTime * 0.08));
  float rotateValue = noiseSample * 0.04 * (1.0 + oneMinusVisibilityProgress * -10.0);
  vec2 modUv = rotate2d(scaledUv, rotateValue);

  vec4 texel = texture2D(tDiffuse, modUv);
  float alpha = step(0.3, texel.a);
  gl_FragColor = vec4(texel.rgb, step((noiseSample + 1.0) / 2.0, uVisibilityProgress) * alpha);
}